import {Image} from "@/types";

export type WhyUsType = {
    id: number;
    title: string;
    description: string;
    image: Image;
}
export const whyUs: WhyUsType[] = [
    {
        id: 1,
        title: 'ASP Level 2 Accredited',
        description: 'Certified & compliant with regulations.',
        image: {
            id: 1,
            url: '/images/why-us/why1.svg',
            original: '/images/why-us/why1.svg',
            title: 'ASP Level 2 Accreditation',
        }
    },
    {
        id: 2,
        title: 'Emergency Electrical Repairs',
        description: 'Safety in critical situations.',
        image: {
            id: 2,
            url: '/images/why-us/why2.svg',
            original: '/images/why-us/why2.svg',
            title: 'Emergency Electrical Repairs',
        }
    },
    {
        id: 3,
        title: 'Meter Box Upgrades',
        description: 'Upgrades that meet modern safety and capacity standards.',
        image: {
            id: 3,
            url: '/images/why-us/why3.svg',
            original: '/images/why-us/why3.svg',
            title: 'Meter Box Upgrades',
        }
    },
    {
        id: 4,
        title: 'Overhead & Underground Services',
        description: 'Installation & maintenance by experts.',
        image: {
            id: 4,
            url: '/images/why-us/why4.svg',
            original: '/images/why-us/why4.svg',
            title: 'Overhead & Underground Services',
        }
    },
    {
        id: 5,
        title: 'Safety Inspections',
        description: 'Compliant in preventing hazards.',
        image: {
            id: 5,
            url: '/images/why-us/why5.svg',
            original: '/images/why-us/why5.svg',
            title: 'Electrical Safety Inspections',
        }
    },
    {
        id: 6,
        title: 'Accredited Team',
        description: 'Qualified electricians for reliable service.',
        image: {
            id: 6,
            url: '/images/why-us/why6.svg',
            original: '/images/why-us/why6.svg',
            title: 'Experienced Level 2 Electricians',
        }
    }
];
